module.exports = __webpack_public_path__ + "img/priority_cover.896789bf.png";